import { useEffect, useRef, useState } from "react";

/** Bir elemanın canlı iç ölçüsünü (px) ResizeObserver ile döndürür — SVG chart'ları kart boyutuna uydurmak için. */
export function useSize<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => {
      const cr = entries[0]?.contentRect;
      if (cr) setSize((s) => (s.width === Math.round(cr.width) && s.height === Math.round(cr.height) ? s : { width: Math.round(cr.width), height: Math.round(cr.height) }));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, size] as const;
}
